import { Container } from "./styles";
import ProductCardComponent from "@/components/ProductCard";
import { SearchResponse } from "@/lib/algolia";

// Cast to fix React 17 + @types/react 18 compatibility issue
const ProductCard = ProductCardComponent as any;

type Props = {
  hits: SearchResponse["hits"];
};

const formatParamValue = (value: string | string[] | null) => {
  return value ? (typeof value === "string" ? value : value?.join(", ")) : "";
};

const Hits: React.FC<Props> = (props) => {
  const { hits } = props;

  return (
    <Container>
      {hits?.map((hit) => {
        // Algolia returns img url, so I build a image object with the same structure of the images returned from sanity
        const image = {
          asset: {
            url: hit.image,
            alt: hit.name,
          },
        };
        const productType = hit["product-type"];
        const routeOfAdministration = hit["route-of-administration"];
        const material = hit["material"];
        const ecopositive = hit["ecopositive"];

        const param1 = {
          label: "Product Type",
          value: formatParamValue(productType),
        };
        const param2 = {
          label: "Route of administration",
          value: formatParamValue(routeOfAdministration),
        };
        const param3 = {
          label: "Material",
          value: formatParamValue(material),
        };
        const eco = {
          value: formatParamValue(ecopositive),
        };

        return (
          <ProductCard
            key={hit.objectID}
            image={image}
            slug={hit.slug}
            name={hit.name}
            subheading={param1.value}
            param1={param2}
            param2={param3}
            eco={eco.value}
          />
        );
      })}
    </Container>
  );
};

export default Hits;
